module.exports = __webpack_public_path__ + "img/572cf0a.webp";